import { HttpTypes } from '@/types';
import { IHistoryPricebookListResponse, IPricebook, IPricebookItems } from '@/types/pricebook';
import { AxiosInstance } from 'axios';

class Pricebook {
  private client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async list(query: HttpTypes.FindParams): Promise<HttpTypes.IResponse<IPricebook[]>> {
    const res = await this.client.get(`/product/pricebook`, { params: query });
    return res.data;
  }

  async update(data: IPricebook): Promise<HttpTypes.IResponse<IPricebook>> {
    const res = await this.client.put(`/product/pricebook/${data.pricebook_id}`, {
      is_stopped: data.is_stopped,
    });
    return res.data;
  }

  async delete(ids: string[]): Promise<HttpTypes.IResponse<IPricebook>> {
    const res = await this.client.put(`/product/pricebook/delete`, {
      pricebook_ids: ids,
    });
    return res.data;
  }

  async getHistory(
    id: string,
    query: HttpTypes.FindParams
  ): Promise<IHistoryPricebookListResponse> {
    const res = await this.client.get(`/product/pricebook/history/${id}`, {
      params: query,
    });
    return res.data;
  }

  async getItems(
    id: string,
    query: HttpTypes.FindParams
  ): Promise<HttpTypes.IResponse<IPricebookItems[]>> {
    const res = await this.client.get(`/product/pricebook/items/${id}`, {
      params: query,
    });
    return res.data;
  }
}

export default Pricebook;
